/**
 * Debounce - run a function once if called a number of times in a duration of time
 * @param  {Function} fn   Function
 * @param  {Number}   wait Duration (in ms)
 */
export function debounce(fn, wait = 200) {
  let timeout = null;

  return function () {
    let context = this;
    let args = arguments;

    clearTimeout(timeout);

    timeout = setTimeout(function () {
      fn.apply(context, args);
    }, wait);
  };
}
